var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseChimney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-chimney-blank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6773 11.1967L19.8291 9.55511L19.8292 4.69584C19.8292 4.38386 19.58 4.16221 19.3034 4.16221L17.1062 4.16195C16.7983 4.16195 16.5804 4.41541 16.5804 4.69558V6.58592L12.8581 3.27986C12.6481 3.09319 12.3859 3 12.1241 3C11.9083 3 11.6314 3.06531 11.3901 3.27986L2.38044 11.1967C1.60847 11.8823 2.09081 13.1474 3.11446 13.1474H4.22942L4.229 18.77C4.229 20.0193 5.22661 21 6.42619 21H17.5375C18.7684 21 19.7346 19.9875 19.7346 18.77L19.797 13.1474L20.88 13.1474C21.4977 13.1474 21.9946 12.6385 21.9946 12.0483C22.0256 11.7268 21.9246 11.4158 21.6773 11.1967Z",
    fill: "#ED7332"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseChimney);
export default __webpack_public_path__ + "static/media/house-chimney.e11bebdb35f32604ada03fceb0a2d813.svg";
export { ForwardRef as ReactComponent };